define('responsive-game-feed/app/scripts/utils/tracking-omniture',['require','exports','module','tracking/omniture'],function(require, exports, module) {
 
 var trackingLib = require("tracking/omniture");
 
 var Tracking = {
		track : function( params ) {
			
			var om = new trackingLib.OmnitureAsync(params);
				om.prop11 = "Dynamic Page View";
            var props = om.assign();
            props.prop22 = null;
            props.prop15 = null;
            props.prop13 = "Major League Baseball: Gameday: Gameday"
            om.fire();
		},
		
		track_color_feed_video_click: function() {
		  
		    this.track({
				events 				 : 'event2,event4',
				dynamic_component	 : 'AtBat: Social',
				dynamic_componentAction : 'AtBat: Social: Real-Time Highlights Click'
			});
		}
		
	}
	
	return Tracking

});
